import { render, staticRenderFns } from "./CreateNew.vue?vue&type=template&id=9f063c48"
import script from "./CreateNew.vue?vue&type=script&lang=js"
export * from "./CreateNew.vue?vue&type=script&lang=js"
import style0 from "./CreateNew.vue?vue&type=style&index=0&id=9f063c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports